import { render, staticRenderFns } from "./regionChart.vue?vue&type=template&id=5529651e&"
import script from "./regionChart.vue?vue&type=script&lang=js&"
export * from "./regionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports